import { render, staticRenderFns } from "./ChatGroupSide.vue?vue&type=template&id=dccfbfdc&scoped=true"
import script from "./ChatGroupSide.vue?vue&type=script&lang=js"
export * from "./ChatGroupSide.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupSide.vue?vue&type=style&index=0&id=dccfbfdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccfbfdc",
  null
  
)

export default component.exports